import { useState } from "react";
import { Alert, Button, Form, Input } from "antd";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import PageBox from "../../layout/PageBox";
import { feedbackRequest } from "../../api/feedback";

export default function PasswordRecovery() {
  const { t } = useTranslation();
  const location = useLocation();
  const resetting = location.pathname === "/reset-password";
  const [token] = useState(() =>
    new URLSearchParams(location.hash.slice(1)).get("token"),
  );
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  // 只接到既有寄信及一次性令牌服務，不在頁面記錄新密碼或令牌。
  const submit = async (values: any) => {
    setBusy(true);
    setError("");
    try {
      await feedbackRequest(
        resetting ? "/auth/v1/reset-password" : "/auth/v1/forgot-password",
        resetting ? { ...values, token } : { email: values.email, side: "web" },
      );
      setDone(true);
      if (resetting) window.history.replaceState(null, "", "/reset-password");
    } catch (e: any) {
      setError(e.message);
    } finally {
      setBusy(false);
    }
  };
  return (
    // 載入遮罩只在送出請求期間開啟，避免 Spin 預設為 true 阻擋整個表單。
    <PageBox spinning={busy}>
      <div className="mx-auto w-full max-w-[480px] px-6 py-10">
        <h1 className="text-2xl font-bold mb-6">
          {t(resetting ? "recovery.reset" : "recovery.forgot")}
        </h1>
        {error && <Alert type="error" title={error} className="mb-4" />}
        {done ? (
          <Alert
            type="success"
            title={t(resetting ? "recovery.reset_done" : "recovery.sent")}
          />
        ) : resetting && !token ? (
          <Alert type="error" title={t("recovery.invalid")} />
        ) : (
          <Form layout="vertical" onFinish={submit}>
            {resetting ? (
              <>
                <p className="mb-4">{t("recovery.rule")}</p>
                <Form.Item
                  name="newPassword"
                  label={t("recovery.new_password")}
                  rules={[
                    { required: true },
                    {
                      pattern:
                        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d@$!%*?&]{8,20}$/,
                      message: t("recovery.rule"),
                    },
                  ]}
                >
                  <Input.Password autoComplete="new-password" />
                </Form.Item>
                <Form.Item
                  name="confirmPassword"
                  label={t("recovery.confirm")}
                  dependencies={["newPassword"]}
                  rules={[
                    { required: true },
                    ({ getFieldValue }) => ({
                      validator: (_, value) =>
                        value === getFieldValue("newPassword")
                          ? Promise.resolve()
                          : Promise.reject(new Error(t("recovery.mismatch"))),
                    }),
                  ]}
                >
                  <Input.Password autoComplete="new-password" />
                </Form.Item>
              </>
            ) : (
              <Form.Item
                name="email"
                label={t("recovery.email")}
                rules={[{ required: true }, { type: "email" }]}
              >
                <Input type="email" autoComplete="email" />
              </Form.Item>
            )}
            <Button type="primary" htmlType="submit" loading={busy}>
              {t(resetting ? "recovery.reset" : "recovery.send")}
            </Button>
          </Form>
        )}
        <Link className="inline-block mt-6" to="/login">
          {t("recovery.back")}
        </Link>
      </div>
    </PageBox>
  );
}
